import React, { useState, useMemo, useEffect, useContext } from 'react'
import { Autocomplete, Button, TextField, Stack, Select, InputLabel, FormControl, MenuItem } from '@mui/material';
import { PORTIONING_LIST, fromExactDropdowns } from '../../../../constants/constantList';
import TPCheckbox from "../../../TemplateProperties/TPCheckbox";
import { useTranslation } from 'react-i18next';
import TestData from './TestData';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import WorkflowSessionModal1 from '../../WorkflowSessionModal1';
import WorkflowSessionModal from '../../WorkflowSessionModal';
import { useDispatch, useSelector } from 'react-redux';
import { api } from '/src/redux/api';
import { debounce } from 'lodash';
import ErrorModal from '../../../ItemProperties/Forms/FieldDataValidation/ErrorModal';
import { customDecoding, customEncoding, stringifyJSONAttributes, stringToBooleanConversion } from '../../../../utils/utilFunctions';
import { ParentScreenCtx } from '../../../../pages/workbench_build/WorkbenchBuild';

const FieldPortioning = ({ okHandler, clear, setClear, selectedNode, updateLength, setHelpDocPath, currTab }) => {
    const { t } = useTranslation();
    const { account } = useSelector((state) => state.queryParams);
    const parentScreen = useContext(ParentScreenCtx);
    const dispatch = useDispatch();
    const [portioningToUse, setPortioningToUse] = useState('NONE');
    const [startPosition, setStartPosition] = useState('');
    const [numberChar, setNumberChar] = useState('');
    const [startValue, setStartValue] = useState('');
    const [endValue, setEndValue] = useState('');
    const [startOccurrance, setStartOccurrance] = useState('');
    const [endOccurrance, setEndOccurrance] = useState('');
    const [lenient, setLenient] = useState("FALSE");
    const [xPath, setXPath] = useState('');
    const [jsonPath, setJsonPath] = useState('');
    const [nameSpace, setNameSpace] = useState('FALSE');
    const [fromExact, setFromExact] = useState('LEFT');
    const [fromRelative, setFromRelative] = useState('LEFT');
    const [startPositionError, setStartPositionError] = useState('');
    const [numberCharError, setNumberCharError] = useState('');
    const [startOccurranceError, setStartOccurranceError] = useState('');
    const [endOccurranceError, setEndOccurranceError] = useState('');
    const [modalStates, setModalStates] = useState({ openModal: false, type: 0 });
    const [testData, setTestData] = useState('');
    const [exactPortionContent, setExactPortionContent] = useState({ portioning_type: "Exact", start_position: '', no_of_chars: '', parse: 'LEFT' });
    const [relativePortionContent, setRelativePortionContent] = useState({ portioning_type: "Relative", start_value: "", end_value: "", start_occurrence: '', end_occurrence: '', parse: 'LEFT', lenient: false });
    const [xPathContent, setXPathContent] = useState({ portioning_type: "XPath", xpath: '', name_space: 'FALSE' });
    const [jsonPathContent, setJsonPathContent] = useState({ portioning_type: "JsonPath", json_path: '' });
    const [regExContent, setRegExContent] = useState({ portioning_type: "RegularExpression", regEx: ''})
    const [testResult, setTestReult] = useState('');
    const [testInput, setTestInput] = useState('');
    const [errorModal, setErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [regEx, setRegEx] = useState('')
    const [workflowModalOpen, setWorkflowModalOpen] = useState({ open: false, isFirstTime: true });

    const handleErrorModal = () => {
        setErrorModal(false);
        setErrorMessage('');
    }

    const fromsExact = useMemo(() => fromExactDropdowns.map((obj, key) =>
        <MenuItem key={key} value={obj.value}>
            {t(obj.text)}
        </MenuItem>
    ), [fromExactDropdowns]);

    const handleChange = (e, setInputValue, setError, msg, name, contentMethod) => {
        const value = e.target.value.trim(); // Trim whitespace from the input value
        if (value === '' || /^[1-9]\d{0,8}$/.test(value)) {
            setInputValue(value);
            onInputChange(name, value === '' ? null : Number(value), contentMethod); // Convert empty string to null
            setError('');
        } else {
            setError(`${msg}.${t('BOX_ZERO_NOT_VALID')}`);
        }
    };

    const handleRelativeChange = (e, setInputValue, setError, msg, name, contentMethod) => {
        const value = e.target.value.trim(); // Trim whitespace from the input value
        if (value === '' || /^[0-9]{1,9}$/.test(value)) {
            setInputValue(value);
            onInputChange(name, value === '' ? null : Number(value), contentMethod); // Convert empty string to null
            setError('');
        } else {
            setError(`${msg}.${t('BOX_ZERO_NOT_VALID')}`);
        }
    };

    const handleBlur = (inputValue, setInputValue, setError, msg) => {
        if (inputValue === '') {
            setError(`${msg}.${t('BOX_ZERO_NOT_VALID')}`);
            setInputValue('');
        } else {
            setError('');
        }
    };

    const valueHandler = (value, previousValue, isFinishClicked) => {
        let finalString = "";
        const valuesArray = Array.isArray(value) ? Object.keys(value) : [];
        if(parentScreen !== 'workflow'){
            valuesArray?.forEach((o, i) => { if (value[o]) finalString += value[o] + ((valuesArray.length - 1) === i ? "" : ",") });
            finalString = previousValue ? ((previousValue || '') + `%${finalString}%`) : `%${finalString}%`;

        } else {
            finalString = previousValue ? ((previousValue || '') + `%${finalString}%`) : `%${value}%`;

        }
        if (portioningToUse === t('BTN_XPATH')) {
            setXPath(finalString);
            onInputChange('xpath', finalString, setXPathContent)
        }
        if (portioningToUse === t('BTN_JSON_PATH')) {
            setJsonPath(finalString);
            onInputChange('json_path', finalString, setJsonPathContent)
        };
    }

    const handleClose2 = (value = false) => {
        if (parentScreen === "workflow") {
            setWorkflowModalOpen({ open: false, isFirstTime: true });
        } else {
            setModalStates({
                openModal: value,
                type: '0'
            });
        }
    }

    const onInputChange = (name, value, setContent) => {
        setContent((prev) => {
            return { ...prev, [name]: value };
        });
    }

    const getTestData = (val) => {
        setTestData(val);
    }

    const handleTestData = () => {
        let contentToUpdate;
        if (portioningToUse === t('BTN_EXACT_PORTIONING')) {
            contentToUpdate = { ...exactPortionContent, test_data: testData };
            setExactPortionContent((prev) => ({ ...prev, test_data: testData }));
        } else if (portioningToUse === t('BTN_REL_PORTIONING')) {
            contentToUpdate = { ...relativePortionContent, test_data: testData };
            setRelativePortionContent((prev) => ({ ...prev, test_data: testData }));
        } else if (portioningToUse === t('BTN_XPATH')) {
            contentToUpdate = { ...xPathContent, test_data: testData };
            setXPathContent((prev) => ({ ...prev, test_data: testData }));
        } else if (portioningToUse === t('BTN_JSON_PATH')) {
            contentToUpdate = { ...jsonPathContent, test_data: testData };
            setJsonPathContent((prev) => ({ ...prev, test_data: testData }));
        } else if(portioningToUse === t('MNU_ITEM_REGEX')) {
            contentToUpdate = {
                ...regExContent, 
                regEx: encodeURIComponent(regExContent.regEx), 
                test_data: testData
            };
            setRegExContent((prev) => ({ ...prev, test_data: testData }));
        }
        testDataFromServer(contentToUpdate);
    };

    const testDataFromServer = (content) => {
        setLoading(true);
        dispatch(api.endpoints.testFieldPortioningData.initiate({
            account,
            data: { ...content }
        },{forceRefetch: true})).then((res) => {
            if (res?.data?.current_state === 'SUCCESS') {
                setTestReult(res?.data?.message);
                setLoading(false);
            } else {
                setErrorModal(true);
                setErrorMessage(res?.data?.message);
                setLoading(false);
            }
        })
    }

    const recieveTestReqeust = (val) => {
        if (val) {
            handleTestData();
        }
    }

    const clearProperties = () => {
        setExactPortionContent({ portioning_type: "Exact", start_position: '', no_of_chars: '', parse: 'LEFT' });
        setRelativePortionContent({ portioning_type: "Relative", start_value: "", end_value: "", start_occurrence: '', end_occurrence: '', parse: 'LEFT', lenient: false });
        setXPathContent({ portioning_type: "XPath", xpath: '', name_space: 'FALSE' });
        setJsonPathContent({ portioning_type: "JsonPath", json_path: '' });
        setRegExContent({ portioning_type: "RegularExpression", regEx: ''})
        setPortioningToUse('NONE');
        setTestReult('');
        setTestInput('');
    }

    const handleDefaultContent = (node) => {
        if (node?.SUBSTRING) {
            const { SUBSTRING } = node;
            if (SUBSTRING?.startsWith('PARSE')) {
                const res = SUBSTRING?.split('%1F');
                setStartOccurrance(customDecoding(res[1]));
                setStartValue(customDecoding(res[2]));
                setEndOccurrance(customDecoding(res[3]));
                setEndValue(customDecoding(res[4]));
                const parseValue = res[0] === 'PARSERIGHT' ? 'RIGHT' : 'LEFT';
                setFromRelative(parseValue);
                setLenient(res[5]?.toUpperCase());                
                setPortioningToUse(t('BTN_REL_PORTIONING'));
                setRelativePortionContent({ ...relativePortionContent, start_value: customDecoding(res[2]), end_value: customDecoding(res[4]), start_occurrence: Number(res[1]), end_occurrence: Number(res[3]), parse: parseValue, lenient: (res[5] && res[5]?.toUpperCase() === 'TRUE') ? true : false });
            } else if (SUBSTRING?.startsWith('XPATH')) {
                const res = SUBSTRING?.split('%1F');
                setXPath(customDecoding(res[1]));
                setNameSpace(res[2]);
                setPortioningToUse(t('BTN_XPATH'));
                setXPathContent({ ...xPathContent, xpath: customDecoding(res[1]), name_space: res[2] || 'FALSE' })
            } else if (SUBSTRING?.startsWith('JSON_PATH')) {
                const res = SUBSTRING?.split('%1F');
                setJsonPath(customDecoding(res[1]));
                setPortioningToUse(t('BTN_JSON_PATH'));
                setJsonPathContent({ ...jsonPathContent, json_path: customDecoding(res[1]) });
            } else if(SUBSTRING?.startsWith('REGEX') || SUBSTRING?.startsWith('REGULAR_EXPRESSION')) {
                const res = SUBSTRING.split('%1F')
                setRegEx(customDecoding(res[1]))
                setPortioningToUse(t('MNU_ITEM_REGEX'))
                setRegExContent({...regExContent, regEx: customDecoding(res[1]) })

            } else if (SUBSTRING === 'NONE') {
                setPortioningToUse('NONE');
            } else {
                const res = SUBSTRING?.split('%1F');
                setFromExact(res[0]);
                setStartPosition(customDecoding(res[1]));
                setNumberChar(customDecoding(res[2]));
                setPortioningToUse(t('BTN_EXACT_PORTIONING'));
                setExactPortionContent({ ...exactPortionContent, start_position: Number(customDecoding(res[1])), no_of_chars: Number(customDecoding(res[2])), parse: res[0] })
            }
        } else {
            setPortioningToUse('NONE');
        }
    }

    const debouncedContentUpdate = debounce(okHandler, 500);

    const handleCurrentUpdates = () => {
        if (startPosition !== '' || numberChar !== '' || startValue !== '' || endValue !== '' || startOccurrance !== '' || endOccurrance !== '' || xPath !== '' || jsonPath !== '' || regEx !== '') {
            let content = '';
            if (portioningToUse === t('BTN_EXACT_PORTIONING')) {
                content = `${fromExact}%1F${customEncoding(startPosition)}%1F${customEncoding(numberChar)}`
            } else if (portioningToUse === t('BTN_REL_PORTIONING')) {
                content = `${fromRelative === 'RIGHT' ? 'PARSERIGHT' : 'PARSELEFT'}%1F${customEncoding(startOccurrance)}%1F${customEncoding(startValue)}%1F${customEncoding(endOccurrance)}%1F${customEncoding(endValue)}${lenient?.toLowerCase() === "true" ? "%1Ftrue" : ""}`
            } else if (portioningToUse === t('BTN_XPATH')) {
                content = `XPATH%1F${customEncoding(xPath)}${nameSpace && `%1F${nameSpace}`}`
            } else if (portioningToUse === t('BTN_JSON_PATH')) {
                content = `JSON_PATH%1F${customEncoding(jsonPath)}`
            } else if(portioningToUse === t('MNU_ITEM_REGEX')) {
                content = `REGEX%1F${customEncoding(regEx)}`
            } else content = 'NONE'
            if (content !== 'NONE') updateLength({ type: 'SUBSTRING', len: 1});
            else updateLength({ type: 'SUBSTRING', len: 0 });
            debouncedContentUpdate({ type: 'SUBSTRING', value: content });
        } else {
            updateLength({ type: 'SUBSTRING', len: 0});
            debouncedContentUpdate({ type: 'SUBSTRING', value: '' });
        }
    }

    useEffect(() => {
        if (clear) {
            clearProperties();
            setClear(false);
        }
    }, [clear])

    useEffect(() => {
        if (selectedNode?.ADVANCE) handleDefaultContent(selectedNode?.ADVANCE);
        else handleDefaultContent(selectedNode);
    }, [])

    useEffect(() => {
        handleCurrentUpdates();
    }, [startPosition, numberChar, nameSpace, fromExact, fromRelative, lenient, startValue, endValue, startOccurrance, endOccurrance, xPath, jsonPath, regEx]);
    
    useEffect(() => {
      if (currTab === 0) {
        if (portioningToUse === t("MNU_ITEM_REGEX")) {
          setHelpDocPath("regex.html");
        } else if (portioningToUse === t("BTN_XPATH")) {
          setHelpDocPath("xpathHelp.html");
        } else if (portioningToUse === t("BTN_JSON_PATH")) {
          setHelpDocPath("jsonpathHelp.html");
        } else if (portioningToUse === t("NONE")) {
            setHelpDocPath("adv_field_portioning.html");
            updateLength({ type: 'SUBSTRING', len: 0 });
            debouncedContentUpdate({ type: 'SUBSTRING', value: null });
        } else {
          setHelpDocPath("adv_field_portioning.html");
        }
      }
    }, [portioningToUse, currTab]);
    
    return (
        <>
            <div className='padding-16'>
                <Stack spacing={"15px"} marginTop="15px">
                    <Autocomplete
                        disablePortal
                        options={PORTIONING_LIST?.map((e) => t(e))}
                        getOptionLabel={(option) => option}
                        value={portioningToUse}
                        sx={{ maxHeight: 300 }}
                        onChange={(e, value) => {
                            setPortioningToUse(value)
                            setTestInput('');
                        }}
                        renderInput={(params) => <TextField
                            {...params}
                            label={t("LBL_SPECIFY_PORTION_TO_USE")}
                            onChange={(e) => {
                                setPortioningToUse(e.target.value)
                                setTestInput('')
                            }}
                            variant="outlined"
                            size="small"
                            name={'PORTION_TO_USE'}
                            autoComplete="off"
                        />
                        }
                    />
                    {portioningToUse === t('BTN_EXACT_PORTIONING') && <>
                        <div className='flex' style={{ gap: '10px' }}>
                            <FormControl sx={{ width: '50%' }} size="small">
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    label={t("LBL_START_POSITION")}
                                    type="text"
                                    className={"uppercase-input width-100"}
                                    name={"START_POSITION"}
                                    onChange={(e) => handleChange(e, setStartPosition, setStartPositionError, t('BOX_ENTER_NUM_FOR_START_POSITION'), 'start_position', setExactPortionContent)}
                                    onBlur={() => handleBlur(startPosition, setStartPosition, setStartPositionError, t('BOX_ENTER_NUM_FOR_START_POSITION'))}
                                    helperText={startPositionError}
                                    error={startPositionError !== ''}
                                    value={startPosition}
                                    autoComplete="off"
                                />
                            </FormControl>
                            <FormControl sx={{ width: '50%' }} size="small">
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    label={t("LBL_NUM_OF_CHARS")}
                                    type="text"
                                    className={"uppercase-input width-100"}
                                    name={"NUM_OF_CHARS"}
                                    onChange={(e) => handleChange(e, setNumberChar, setNumberCharError, t('BOX_ENTER_NUM_FOR_END_POSITION'), 'no_of_chars', setExactPortionContent)}
                                    onBlur={() => handleBlur(numberChar, setNumberChar, setNumberCharError, t('BOX_ENTER_NUM_FOR_END_POSITION'))}
                                    value={numberChar}
                                    error={numberCharError !== ''}
                                    helperText={numberCharError}
                                    autoComplete="off"
                                />
                            </FormControl>
                        </div>
                        <FormControl
                            variant="outlined"
                            className="width-100"
                            size="small">
                            <InputLabel id="fromExactDropdown">
                                {t("LBL_FROM")}
                            </InputLabel>
                            <Select
                                className={"width-100"}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            maxHeight: 300,
                                        },
                                    },
                                }}
                                name="LBL_FROM"
                                value={fromExact}
                                labelId="fromExactDropdown"
                                label={t("LBL_FROM")}
                                id="fromExactDropdown"
                                onChange={(e) => {
                                    setFromExact(e.target.value)
                                    onInputChange('parse', e.target.value, setExactPortionContent)
                                }}
                            >
                                {fromsExact}
                            </Select>
                        </FormControl>
                    </>}
                    {portioningToUse === t('BTN_REL_PORTIONING') && <>
                        <div className='flex' style={{ gap: '10px' }}>
                            <FormControl className="width-100" size="small">
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    label={t("LBL_START_VAL")}
                                    type="text"
                                    className={"width-100"}
                                    name={"LBL_START_VAL"}
                                    value={startValue}
                                    onChange={(e) => {
                                        setStartValue(e.target.value);
                                        onInputChange('start_value', e.target.value, setRelativePortionContent)
                                    }}
                                    autoComplete="off"
                                />
                            </FormControl>
                            <FormControl className="width-100" size="small">
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    label={t("LBL_END_VAL")}
                                    type="text"
                                    className={"width-100"}
                                    name={"LBL_END_VAL"}
                                    value={endValue}
                                    onChange={(e) => {
                                        setEndValue(e.target.value);
                                        onInputChange('end_value', e.target.value, setRelativePortionContent)
                                    }}
                                    autoComplete="off"
                                />
                            </FormControl>
                        </div>
                        <FormControl
                            variant="outlined"
                            className="width-100"
                            size="small">
                            <InputLabel id="fromExactDropdown">
                                {t("LBL_FROM")}
                            </InputLabel>
                            <Select
                                className={"width-100"}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            maxHeight: 300,
                                        },
                                    },
                                }}
                                name="LBL_FROM"
                                value={fromRelative}
                                labelId="fromExactDropdown"
                                label={t("LBL_FROM")}
                                id="fromExactDropdown"
                                onChange={(e) => {
                                    setFromRelative(e.target.value)
                                    onInputChange('parse', e.target.value, setRelativePortionContent);
                                }}
                            >
                                {fromsExact}
                            </Select>
                        </FormControl>
                        <div className='flex' style={{ gap: '10px' }}>
                            <FormControl className="width-100" size="small">
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    label={t("LBL_START_OCCUR")}
                                    type="text"
                                    className={"uppercase-input width-100"}
                                    name={"LBL_START_OCCUR"}
                                    value={startOccurrance}
                                    onChange={(e) => handleRelativeChange(e, setStartOccurrance, setStartOccurranceError, t('BOX_ENTER_NUM_FOR_START_OCCUR'), 'start_occurrence', setRelativePortionContent)}
                                    onBlur={() => handleBlur(startOccurrance, setStartOccurrance, setStartOccurranceError, t('BOX_ENTER_NUM_FOR_START_OCCUR'))}
                                    helperText={startOccurranceError}
                                    error={startOccurranceError !== ''}
                                    autoComplete="off"
                                />
                            </FormControl>
                            <FormControl className="width-100" size="small">
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    label={t("LBL_END_OCCUR")}
                                    type="text"
                                    className={"uppercase-input width-100"}
                                    name={"LBL_END_OCCUR"}
                                    value={endOccurrance}
                                    onChange={(e) => handleRelativeChange(e, setEndOccurrance, setEndOccurranceError, t('BOX_ENTER_NUM_FOR_END_OCCUR'), 'end_occurrence', setRelativePortionContent)}
                                    onBlur={() => handleBlur(endOccurrance, setEndOccurrance, setEndOccurranceError, t('BOX_ENTER_NUM_FOR_END_OCCUR'))}
                                    helperText={endOccurranceError}
                                    error={endOccurranceError !== ''}
                                    autoComplete="off"
                                />
                            </FormControl>
                        </div>
                        <TPCheckbox
                            label={t("LBL_LENIENT")}
                            checked={stringToBooleanConversion(lenient)}
                            handleCheck={(checked) => {
                                setLenient(stringifyJSONAttributes(checked));
                                onInputChange('lenient', checked, setRelativePortionContent);
                            }}
                        />
                    </>}
                    {portioningToUse === t('BTN_XPATH') && <>
                        <FormControl className="width-100" size="small">
                            <div className="flex">
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    label={t("LBL_XPATH")}
                                    type="text"
                                    className={"width-100"}
                                    name={"XPATH"}
                                    value={xPath}
                                    autoComplete="off"
                                    onChange={(e) => {
                                        onInputChange('xpath', e.target.value, setXPathContent)
                                        setXPath(e.target.value)
                                    }}
                                />
                                <Button
                                    variant="outlined"
                                    size="small"
                                    disableElevation
                                    className="margin-left-4"
                                    sx={{
                                        width: "40px",
                                        padding: "4px 8px",
                                        minWidth: "40px",
                                    }}
                                    onClick={() => {
                                        if (parentScreen === "workflow") {
                                            setWorkflowModalOpen({ open: true, isFirstTime: true });
                                        } else {
                                            setModalStates({
                                                openModal: true,
                                                type: '0'
                                            });
                                        }
                                    }}>
                                    <MoreHorizIcon fontSize="small" />
                                </Button>
                            </div>
                        </FormControl>
                        <FormControl
                            variant="outlined"
                            className="width-100"
                            size="small">
                            <InputLabel id="nameSpaceDropdown">
                                {t("LBL_NAME_SPACE")}
                            </InputLabel>
                            <Select
                                className={"width-100"}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            maxHeight: 300,
                                        },
                                    },
                                }}
                                name="LBL_NAME_SPACE"
                                value={nameSpace}
                                labelId="nameSpaceDropdown"
                                label={t("LBL_NAME_SPACE")}
                                id="nameSpaceDropdown"
                                onChange={(e) => {
                                    setNameSpace(e.target.value)
                                    onInputChange('name_space', e.target.value, setXPathContent)
                                }}
                            >
                                {['FALSE', 'TRUE'].map((obj, key) =>
                                    <MenuItem key={key} value={obj}>
                                        {t(obj)}
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </>}
                    {portioningToUse === t('BTN_JSON_PATH') && <>
                        <FormControl className="width-100" size="small">
                            <div className="flex">
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    label={t("LBL_JSONPATH")}
                                    type="text"
                                    className={"width-100"}
                                    name={"JSONPATH"}
                                    value={jsonPath}
                                    autoComplete="off"
                                    onChange={(e) => {
                                        setJsonPath(e.target.value);
                                        onInputChange('json_path', e.target.value, setJsonPathContent)
                                    }}
                                />
                                <Button
                                    variant="outlined"
                                    size="small"
                                    disableElevation
                                    className="margin-left-4"
                                    sx={{
                                        width: "40px",
                                        padding: "4px 8px",
                                        minWidth: "40px",
                                    }}
                                    onClick={() => {
                                        if (parentScreen === "workflow") {
                                            setWorkflowModalOpen({ open: true, isFirstTime: true });
                                        } else {
                                            setModalStates({
                                                openModal: true,
                                                type: '0'
                                            });
                                        }
                                    }}>
                                    <MoreHorizIcon fontSize="small" />
                                </Button>
                            </div>
                        </FormControl>
                    </>}
                    {portioningToUse === t('MNU_ITEM_REGEX') && <>
                      <TextField
                         size='small'
                         variant='outlined'
                         value={regEx}
                         label={t('LBL_REGEX')}
                         name='regExInput'
                         autoComplete='off'
                         className='width-100'
                         onChange={(e) => {
                            setRegEx(e.target.value)
                            onInputChange('regEx', e.target.value, setRegExContent)
                         }}
                      />
                    </>}
                    <TestData clear={clear} input={testInput} testResult={testResult} getTestData={getTestData} type={'LBL_TEST_YOUR_PORTION_LOGIC_HERE'} sendTestRequest={recieveTestReqeust} isLoading={loading} />
                </Stack>
            </div>
            {parentScreen === "workflow" ? (
                <WorkflowSessionModal
                    valueLabel={portioningToUse === t('BTN_XPATH') ? t("LBL_XPATH") : t("LBL_JSONPATH")}
                    showAccountData={true}
                    showCallingWorkflow={true}
                    showDateAndTime={true}
                    showSystemData={true}
                    showWorkflowSession={true}
                    openModal={workflowModalOpen}
                    setModalOpen={setWorkflowModalOpen}
                    handleClose={handleClose2}
                    initialValue={(portioningToUse === t('BTN_XPATH') ? xPath : jsonPath) || ''}
                    valuesHandler={valueHandler}
                />
            ) : (
                <WorkflowSessionModal1
                    previousValue={(portioningToUse === t('BTN_XPATH') ? xPath : jsonPath) || ''}
                    showSelection={"true"}
                    valueHandler={valueHandler}
                    handleClose={handleClose2}
                    openModal={modalStates.openModal}
                    sourceType="callingWorkflow"
                    selection={"single"}
                />
            )}
            {errorModal && <ErrorModal
                errorModal={errorModal}
                handleErrorModal={handleErrorModal}
                errorMessage={errorMessage}></ErrorModal>}
        </>
    )
}

export default FieldPortioning